import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HouseDoorFill,
  Building,
  PeopleFill,
  BoxSeam,
  Shop,
  CartCheckFill,
  ArchiveFill,
  PersonCheckFill,
  GraphUp,
  BagFill,
  FileEarmarkTextFill,
  BoxArrowRight,
  PersonCircle,
  XLg,
  ChevronDoubleLeft,
  ChevronDoubleRight,
} from "react-bootstrap-icons";
import { Nav } from "react-bootstrap";

function Sidebar({
  collapsed,
  toggleSidebar,
  isMobile = false,
  sidebarVisible = true,
  closeSidebarMobile,
}) {
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [showAdminDetails, setShowAdminDetails] = useState(false);
  const [role, setRole] = useState("Admin"); // default fallback

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = sidebarVisible ? "hidden" : "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebarVisible, isMobile]);

  useEffect(() => {
    if (!isMobile || !sidebarVisible) return;
    function handleOutsideClick(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebarMobile();
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isMobile, sidebarVisible, closeSidebarMobile]);

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  const menuItems = [
    { label: "Dashboard", icon: <HouseDoorFill />, path: "/dashboard" },
    { label: "Sales", icon: <GraphUp />, path: "/sales" },
    { label: "Customers", icon: <PersonCheckFill />, path: "/customers" },
    { label: "Stocks", icon: <ArchiveFill />, path: "/stocks" },
    { label: "Personal Stocks", icon: <BagFill />, path: "/personal_stock" },
    { label: "Purchases", icon: <CartCheckFill />, path: "/purchases" },
    { label: "Products", icon: <BoxSeam />, path: "/products" },
    { label: "Report", icon: <FileEarmarkTextFill />, path: "/report" },
    { label: "Branch", icon: <Building />, path: "/branch" },
    { label: "Users", icon: <PeopleFill />, path: "/user" },
  ];

  const filteredMenuItems =
    role === "Staff"
      ? menuItems.filter(
          (item) =>
            !["Branch", "Users", "Report", "Personal Stocks"].includes(item.label)
        )
      : role === "Manager"
      ? menuItems.filter((item) => item.label !== "Personal Stocks")
      : menuItems;

  return (
    <>
      <style>{`
        .hide-scrollbar {
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .sidebar-container {
          width: 240px;
          min-width: 240px;
          max-width: 240px;
          transition: left 0.3s ease, width 0.3s ease, min-width 0.3s ease, max-width 0.3s ease;
          overflow: hidden;
        }
        .sidebar-container.collapsed {
          width: 80px;
          min-width: 80px;
          max-width: 80px;
        }
        .label-text {
          transition: opacity 0.3s ease, width 0.3s ease;
          white-space: nowrap;
          overflow: hidden;
          opacity: 1;
          width: auto;
        }
        .collapsed .label-text {
          opacity: 0;
          width: 0;
        }
        .collapsed .sidebar-header img {
          max-width: 40px !important;
          transition: max-width 0.3s ease, opacity 0.3s ease;
          opacity: 0;
        }
        .sidebar-header img {
          max-width: 160px;
          max-height: 50px;
          transition: max-width 0.3s ease, opacity 0.3s ease;
          opacity: 1;
        }
        .btn-toggle {
          transition: all 0.3s ease;
        }
      `}</style>

      {isMobile && sidebarVisible && (
        <div
          onClick={closeSidebarMobile}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 1050,
          }}
        />
      )}

      <div
        ref={sidebarRef}
        className={`d-flex flex-column vh-100 bg-danger text-white small sidebar-container ${
          collapsed && !isMobile ? "collapsed" : ""
        }`}
        style={{
          position: isMobile ? "fixed" : "relative",
          top: 0,
          left: isMobile ? (sidebarVisible ? 0 : "-250px") : 0,
          zIndex: 1100,
          boxShadow: isMobile ? "2px 0 5px rgba(0,0,0,0.5)" : "none",
        }}
      >
        {isMobile && sidebarVisible && (
          <div className="d-flex justify-content-end p-2 border-bottom border-white border-opacity-25">
            <button
              onClick={closeSidebarMobile}
              className="btn btn-light rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{ width: "38px", height: "38px" }}
              aria-label="Close Sidebar"
              title="Close Sidebar"
            >
              <XLg size={20} className="text-danger" />
            </button>
          </div>
        )}

        <div
          className="sidebar-header d-flex align-items-center justify-content-between px-3 py-4 border-bottom border-white border-opacity-25 position-relative"
          style={{ height: "70px", userSelect: "none" }}
        >
          <h2
            className="mt-2 label-text"
            style={{ fontFamily: "sans-serif", fontWeight: "bold" }}
          >
            MRF Tyres
          </h2>

          {!isMobile && (
            <button
              onClick={toggleSidebar}
              className="btn btn-light rounded-circle d-flex align-items-center justify-content-center shadow-sm btn-toggle"
              style={{
                width: "35px",
                height: "38px",
                position: collapsed ? "absolute" : "relative",
                top: collapsed ? "10px" : "auto",
                right: collapsed ? "25px" : "auto",
                zIndex: 1,
              }}
              aria-label={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
              title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
            >
              {collapsed ? (
                <ChevronDoubleRight size={20} className="text-danger" />
              ) : (
                <ChevronDoubleLeft size={20} className="text-danger" />
              )}
            </button>
          )}
        </div>

        <div className="flex-grow-1 overflow-auto hide-scrollbar px-2">
          <Nav className="flex-column mt-3">
            {filteredMenuItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={index}
                  to={item.path}
                  onClick={() => isMobile && closeSidebarMobile()}
                  className={`d-flex align-items-center mb-2 rounded ${
                    isActive
                      ? "bg-white bg-opacity-25 text-white fw-semibold"
                      : "text-white text-opacity-40"
                  }`}
                  style={{
                    textDecoration: "none",
                    padding:
                      collapsed && !isMobile
                        ? "0.75rem 0.5rem"
                        : "0.75rem 1rem",
                    transition: "padding 0.3s ease",
                  }}
                >
                  <div className="d-flex align-items-center w-100">
                    <div
                      style={{ width: "30px", paddingLeft: "15px" }}
                      className="me-3 d-flex justify-content-center"
                    >
                      {item.icon}
                    </div>
                    <span className="label-text flex-grow-1">{item.label}</span>
                  </div>
                </Link>
              );
            })}
          </Nav>
        </div>

        <div
          className="p-3 border-top border-white border-opacity-25 flex-shrink-0"
          style={{ userSelect: "none" }}
        >
          <div
            className="d-flex align-items-center gap-3 bg-white text-danger rounded p-2 mb-3"
            style={{ cursor: "pointer" }}
            onClick={() => setShowAdminDetails(!showAdminDetails)}
            title={`${role} Details`}
          >
            <PersonCircle size={collapsed && !isMobile ? 15 : 15} />
            <span className="small label-text">{role}</span>
          </div>

          <button
            className="btn btn-light w-100 d-flex align-items-center text-danger"
            style={{
              fontSize: "0.75rem",
              padding: collapsed && !isMobile ? "0.6rem" : "0.6rem 1rem",
              transition: "padding 0.3s ease",
            }}
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("username");
              localStorage.removeItem("role");
              window.location.href = "/";
            }}
            title="Log Out"
          >
            <div
              className="logout-button"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <BoxArrowRight size={collapsed && !isMobile ? 15 : 15} />
              <span className="label-text px-3">
                {(!collapsed || isMobile) && "Log out"}
              </span>
            </div>
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;